import { ProductImages } from "shared/product/ProductSection/ProductImages";
import { ProductSpecifications } from "shared/product/ProductSection/ProductSpecifications";
import { HorizontalSeparator } from "ui/HorizontalSeparator";

import { StickyCommitmentDetails } from "./StickyCommitmentDetails";

export const ProductSection = () => (
  <>
    <section className="lg:flex lg:justify-center">
      <ProductImages className="hidden pb-5 lg:block" />
      <ProductSpecifications />
    </section>

    <HorizontalSeparator className="w-full" />

    <StickyCommitmentDetails />
  </>
);
